// Module
import * as React from "react";
// Style
import "./c-connectWithUs.scss";

// business needs
import tallbuilding from "./img/AL.190207.COH.WEBW.Connect1.jpg";
import computer from "./img/AL.190207.COH.WEBW.Connect2.jpg";
import money from "./img/AL.190207.COH.WEBW.Connect3.jpg";
import crowd from "./img/AL.190207.COH.WEBW.Connect4.jpg";
import meeting from "./img/AL.190207.COH.WEBW.Connect5.jpg";
import { Link } from "gatsby";
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next';

interface IProps extends WithTranslation {
    prop: any;
  }
  
  interface IState {
    state: any;
  }

const ConnectWithUs = ({},{
    prop,
}:IProps) => {
    const { t } = useTranslation('info');
    return (
        <div className="container-fluid section-padding-tb96">
            <div className="container">
                <h2 className="section-header all-cap">
                    <bdi className="section-header all-cap text-highlight">
                        {t(`ConnectWithUs.title`)}{" "}
                    </bdi>
                    {t(`ConnectWithUs.SubTitle`)}
                </h2>
                <div className="row">
                    <div className="col-sm-12 col-md-6 itemCol">
                        <Link to="/blog">
                            <img
                                className="itemCol__img rounded"
                                src={tallbuilding}
                                alt="Hong Kong Building"
                            />
                            <span className="itemCol__subhead   body-short-texts">
                                {t(`ConnectWithUs.Blogs`)}
                            </span>
                        </Link>
                    </div>
                    <div className="col-sm-12 col-md-6 itemCol">
                        <a href="https://www.meetup.com/Multi-Network-Business-Community/" target="_blank">
                            <img
                                className="itemCol__img rounded"
                                src={computer}
                                alt="Iphone"
                            />
                            <span className="itemCol__subhead   body-short-texts">
                                {t(`ConnectWithUs.meetup`)}
                            </span>
                        </a>
                    </div>
                    <div className="col-sm-12 col-md-6 itemCol">
                        <a href="https://www.linkedin.com/company/centre-o/" target="_blank">
                            <img
                                className="itemCol__img rounded"
                                src={money}
                                alt=""
                            />
                            <span className="itemCol__subhead   body-short-texts">
                                {t(`ConnectWithUs.Linkedln`)}
                            </span>
                        </a>
                    </div>
                    <div className="col-sm-12 col-md-6 itemCol">
                        <a href="https://www.facebook.com/centreobusinesscentre/" target="_blank">
                            <img
                                className="itemCol__img rounded"
                                src={crowd}
                                alt=""
                            />
                            <span className="itemCol__subhead   body-short-texts">
                                {t(`ConnectWithUs.Facebook`)}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConnectWithUs;
